import { render, staticRenderFns } from "./Manifeste.vue?vue&type=template&id=117a7278&"
import script from "./Manifeste.vue?vue&type=script&lang=js&"
export * from "./Manifeste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports